import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

import Maintenance from './Maintenance';
import TestDrive from './TestDrive';

let form;
switch (window.JLR_BOOKING_WIDGET.form)  {
    case 'Maintenance':
        form = Maintenance;
        break;
    case 'TestDrive':
        form = TestDrive;
        break;
}


Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [createPersistedState()],


    state: {
        brandId: null,
        dealerId: null,
        locale: 'ru',

        cities: [],
        userCoords: {
            lat: null,
            lng: null
        },
        userLocation: '',

        ...form.state
    },


    getters: {
        ...form.getters
    },


    mutations: {
        setLocale: function (state, payload) {
            state.locale = payload;
        },

        setUserCoords: function (state, payload) {
            state.userCoords = payload;
        },

        setUserLocation: function (state, payload) {
            state.userLocation = payload
        },

        ...form.mutations
    },


    actions: {
        searchUserCity: function({commit}, payload) {
            const geocoder = new google.maps.Geocoder;
            return new Promise((resolve, reject) => {
                geocoder.geocode({'location': payload}, res => {
                    res.forEach(place => {
                        if(place.types.indexOf('locality') !== -1) {
                            const userCity = {
                                description: place.formatted_address,
                                place_id: place.place_id
                            };
                            commit('setUserLocation', userCity);
                            resolve(userCity)
                        }
                    })
                })
            })
        },

        ...form.actions
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js